import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Observable, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/core/interfaces/response.interface';
import { IPushDeviceRegisterReq, PushPlatform } from 'src/app/core/interfaces/push.interface';
import { DeviceDetectionService } from './device-detection.service';

export function toPushPlatform(p: string): PushPlatform | null {
	switch (p) {
		case 'android':
			return 'ANDROID';
		case 'ios':
			return 'IOS';
		default:
			return null;
	}
}

@Injectable({
	providedIn: 'root'
})
export class PushDevicesService {

	constructor(private http: HttpClient, private deviceDetectionService: DeviceDetectionService) { }

	public register(body: IPushDeviceRegisterReq): Observable<string> {
		return this.http.post<IResponse>(`${environment.apiUrl}push/devices`, body).pipe(map(response => {
			return response.data;
		}));
	}

	public async registerDevice(token: string): Promise<void> {
		const platform = toPushPlatform(Capacitor.getPlatform());
		if (!token || !platform) {
			return;
		}

		try {
			const deviceInfo = await this.deviceDetectionService.getDeviceInfo();
			const deviceLabel = `${deviceInfo.manufacturer} ${deviceInfo.model}`;
			await firstValueFrom(this.register({ token, platform, deviceLabel }));
		} catch (error) {
			console.error('Error registering push device:', error);
		}
	}
}
